import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.00219 3.00002L18.0022 3C19.659 3 21.0022 4.34314 21.0022 6V16.0358C21.0022 17.6926 19.6591 19.0357 18.0022 19.0358L15.3759 19.0358L12.6359 21.3058C12.2642 21.6138 11.7255 21.6123 11.3555 21.3021L8.65182 19.0358H6.0022C4.34534 19.0358 3.0022 17.6926 3.0022 16.0358V6.00002C3.0022 4.34317 4.34534 3.00002 6.00219 3.00002ZM12 15C12.3333 15 16 13.1406 16 10.625C16 8.875 14.8889 8 13.7778 8C12.6667 8 12 8.65625 12 8.65625C12 8.65625 11.3333 8 10.2222 8C9.11111 8 8 8.875 8 10.625C8 13.1406 11.6667 15 12 15Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "paint0_linear_3364_2775",
    x1: "12.0022",
    y1: "3",
    x2: "12.0022",
    y2: "21.5358",
    gradientUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("stop", { "stop-color": "currentColor" }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "currentColor"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }